import React from 'react';
import classNames from 'classnames';
import { next, previous, ellipses } from '../../../constants/pagination';
var range = function (start, end) {
    return new Array(end > 0 ? end - start : 0)
        .fill(start)
        .map(function (value, idx) { return value + idx; });
};
export function getPaginationNumbers(nPages, currentPageNumber) {
    var hasNextAndPrev = nPages > 7;
    var low = Math.max(1, Math.min(currentPageNumber - 3, nPages - 6));
    var high = Math.min(nPages, low + 6) + 1;
    // always create 7 items when there are 7 or more pages
    var numbers = range(low, high);
    if (hasNextAndPrev) {
        // add previous arrows when beginning pages are not visible
        if (currentPageNumber > 4) {
            numbers.splice(0, 2, previous, ellipses);
        }
        // add next arrows when end pages are not visible
        if (currentPageNumber < nPages - 3) {
            numbers.splice(numbers.length - 2, 2, ellipses, next);
        }
        // show last page on first pagination
        if (currentPageNumber === 1) {
            numbers.splice(numbers.length - 3, 2, ellipses, nPages);
        }
    }
    return numbers;
}
function getCurrentClass(page, n) {
    return page === n ? ' hd-pagination__current' : '';
}
var paginationItemClassName = 'hd-pagination__item';
export function Pagination(_a) {
    var className = _a.className, nPages = _a.nPages, onChangePage = _a.onChangePage, page = _a.page;
    var items = getPaginationNumbers(nPages, page).map(function (n, index) {
        switch (n) {
            case previous:
                return (React.createElement("li", { key: n, className: "".concat(paginationItemClassName, " hd-pagination__button") },
                    React.createElement("button", { type: "button", onClick: function () { return onChangePage(page - 1); }, className: "hd-pagination__link" }, "Prev")));
            case next:
                return (React.createElement("li", { key: n, className: "".concat(paginationItemClassName, " hd-pagination__button") },
                    React.createElement("button", { type: "button", onClick: function () { return onChangePage(page + 1); }, className: "hd-pagination__link" }, "Next")));
            case ellipses:
                return (React.createElement("li", { key: 'ellipses-' + index, className: paginationItemClassName },
                    React.createElement("span", { className: "hd-pagination__spacer sui-leading-[normal]" }, n)));
            default:
                return (React.createElement("li", { key: n, className: paginationItemClassName },
                    React.createElement("button", { "data-testid": "pagination-button-number", type: "button", onClick: function () { return onChangePage(+n); }, className: "hd-pagination__link ".concat(getCurrentClass(page, Number(n))) }, n)));
        }
    });
    return (React.createElement("div", { className: "container" },
        React.createElement("nav", { className: classNames('hd-pagination', className) },
            React.createElement("ul", { className: "hd-pagination__wrapper" }, items))));
}
